import { render } from "./D_editBoardList.vue?vue&type=template&id=25242b9e&scoped=true"
import script from "./D_editBoardList.vue?vue&type=script&lang=js"
export * from "./D_editBoardList.vue?vue&type=script&lang=js"

import "./D_editBoardList.vue?vue&type=style&index=0&id=25242b9e&scoped=true&lang=css"
/* custom blocks */
import block0 from "./D_editBoardList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25242b9e"]])

export default __exports__